import React from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'

import './Loading.css'

const Loading = ({ style }) => {
  return (<div styleName={cx('loading', style)}>
    <div styleName='dot' />
    <div styleName='dot' />
    <div styleName='dot' />
  </div>)
}

Loading.propTypes = {
  style: PropTypes.oneOf(['primary', 'secondary', 'link'])
}

export default Loading
